module.exports = __webpack_public_path__ + "Montserrat-Regular-6a18f75e59e23e7f23b8a4ef70d748cd.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/montserrat/Montserrat-Regular.ttf
// module id = 874
// module chunks = 86